import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'mprd-flex-emergency-confirmation-pxsplus',
  templateUrl: './flex-emergency-confirmation-pxsplus.component.html',
})
export class FlexEmergencyConfirmationPxsplusComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {}

  routeToStep1(): void {
    this.router.navigate(['/pxsplus/flex-emergency-entry']);
  }
}
